/**
 * /vijesti/ blog archive — category filter chips + AJAX load more.
 * No page reload; re-uses the same `blog-card` markup fragment the server
 * renders for both the initial page load and every AJAX response.
 */

let activeController = null;

export default function vijestiArchive() {
	const root = document.querySelector('.js-vijesti-grid');
	if (!root) {
		return;
	}

	const filters = document.querySelectorAll('.js-vijesti-filters .vijesti-archive__filter');
	const loadMoreButton = document.querySelector('.js-vijesti-load-more');
	const emptyState = document.querySelector('.js-vijesti-empty');

	filters.forEach((button) => {
		button.addEventListener('click', () => {
			if (button.classList.contains('active')) {
				return;
			}

			filters.forEach((btn) => {
				btn.classList.remove('active');
				btn.setAttribute('aria-selected', 'false');
			});
			button.classList.add('active');
			button.setAttribute('aria-selected', 'true');

			root.dataset.category = button.dataset.category;
			root.dataset.page = '1';

			fetchPosts({ replace: true });
		});
	});

	if (loadMoreButton) {
		loadMoreButton.addEventListener('click', () => {
			root.dataset.page = String(Number(root.dataset.page || '1') + 1);
			fetchPosts({ replace: false });
		});
	}

	function fetchPosts({ replace }) {
		if (activeController) {
			activeController.abort();
		}
		activeController = new AbortController();

		if (loadMoreButton) {
			loadMoreButton.disabled = true;
		}
		root.classList.add('is-loading');

		const body = new URLSearchParams({
			action: 'vijesti_filter_posts',
			nonce: root.dataset.nonce,
			category: root.dataset.category || '0',
			paged: root.dataset.page || '1',
			exclude: root.dataset.exclude || '0',
		});

		fetch(window.menaObject.ajaxurl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body,
			signal: activeController.signal,
		})
			.then((response) => response.json())
			.then((response) => {
				if (!response || !response.success) {
					return;
				}

				const { html, hasMore, found } = response.data;

				if (replace) {
					root.innerHTML = html;
				} else {
					root.insertAdjacentHTML('beforeend', html);
				}

				if (emptyState) {
					emptyState.hidden = found > 0;
				}

				if (loadMoreButton) {
					loadMoreButton.hidden = !hasMore;
					loadMoreButton.disabled = false;
				}
			})
			.catch((error) => {
				if (error.name !== 'AbortError' && loadMoreButton) {
					loadMoreButton.disabled = false;
				}
			})
			.finally(() => {
				root.classList.remove('is-loading');
			});
	}
}
